<template>
  <div :class="isApp == true ? '' : 'content'">
    <Header></Header>
    <div class="main" v-show="isApp == true ? false : true">
      <MainLeft></MainLeft>
      <div class="main_content">
        <div class="zanwie"></div>
        <div class="carousel">
          <el-carousel indicator-position="outside" height="21.875rem">
            <el-carousel-item v-for="(item, index) in carouselImg" :key="index">
              <img
                :src="item.image"
                alt=""
                class="carousel_img"
                @click="goBannerNews(item)"
              />
              <!-- <img :src="require(item.img)" alt="" class="carousel_img" /> -->
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="zanwie"></div>
        <div class="news">
          <div class="new_title" @click="test">{{ $t("index.new") }}</div>

          <!-- 所有。系统、活动。客服 -->
          <div class="news_list subb">
            <div
              class="news_list_title"
              v-for="(item, index) in newsList"
              :key="index"
              @click="changeNews(item, index)"
            >
              <div :class="newColor[index]">
                <div :class="active == index ? 'colorBlack' : 'colorWhite'">
                  {{ item.category }}
                </div>
              </div>
            </div>
          </div>

          <!-- ispc -->
          <div class="zanwei_sub">
            <div class="zan"></div>

            <div class="" v-for="(item, index) in allList" :key="index">
              <div class="itemSub">
                <div class="itemSub_type">
                  <div class="itemSub_type_sub">{{ item.category }}</div>
                </div>
                <div class="itemSub_time">{{ item.create_time }}</div>
                <div class="itemSub_content subb" @click="goNews(item)">
                  {{ item.title }}
                </div>
              </div>
            </div>

            <div class="noNews" v-show="isNoNews">{{ $t("index.noNew") }}</div>
            <!-- <div class="more" @click="goNews(item)">
              <div class="more_look">
                <span>{{ $t("index.more") }}</span
                ><i class="el-icon-caret-right"></i>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="isapp" v-show="isApp == false ? false : true">
      <div>
        <div class="cash-wrap">
          <div class="logo-mobile">
            <img src="../assets/index/tigerLogo.png" alt="" />
          </div>
          <div class="isApp_maintain mobile">
            <span>{{ $t("nav.maintain") }}</span>
            <span>{{ $t("nav.time") }}</span>
          </div>
          <div class="btn-cash" @click="goWhere">
            <a class="buy">
              <img
                v-show="isbuyIconZh"
                src="../assets/index/h5-gift-cash.png"
                alt=""
              />
              <img
                v-show="isbuyIconEn"
                src="../assets/index/h5-gift-en.png"
                alt=""
              />
            </a>
          </div>
        </div>
        <div class="carousel">
          <el-carousel indicator-position="outside" height="9.6875rem">
            <el-carousel-item
              class="isapp_carousel"
              v-for="(item, index) in carouselImg"
              :key="index"
            >
              <img
                :src="item.image"
                alt=""
                class="isapp_carousel_img"
                @click="goBannerNews(item)"
              />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="isapp_news">
          <div class="new_title" @click="test">{{ $t("index.new") }}</div>
          <div class="isapp_news_list">
            <div
              class="news_list_title"
              v-for="(item, index) in newsList"
              :key="index"
              @click="changeNews(item, index)"
            >
              <div :class="newColor[index]">
                <div
                  :class="
                    active == index ? 'isapp_colorBlack' : 'isapp_colorWhite'
                  "
                >
                  {{ item.category }}
                </div>
              </div>
            </div>
          </div>
          <div class="isapp_zanwei_sub">
            <div class="zan"></div>
            <div class="" v-for="(item, index) in allList" :key="index">
              <div class="isapp_itemSub">
                <div class="itemSub_type">
                  <div class="isapp_itemSub_type_index">
                    {{ item.category }}
                  </div>
                </div>
                <div class="isapp_itemSub_time">{{ item.create_time }}</div>
                <div class="isapp_itemSub_content" @click="goNews(item)">
                  {{ item.title }}
                </div>
              </div>
            </div>
            <div class="noNews" v-show="isNoNews">{{ $t("index.noNew") }}</div>
            <!-- <div class="isapp_more">
              <div class="more_look">
                <span>{{ $t("index.more") }}</span
                ><i class="el-icon-caret-right"></i>
              </div>
            </div> -->
          </div>
        </div>
        <div id="qrcodeBtn-wrap">
          <div class="qrcode-wrap">
            <!-- ios -->
            <div class="qrcode-system">
              <div class="qrcode-mobile">
                <a
                  class="erwma"
                  href="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282"
                  target="_blank"
                >
                  <img src="../assets/index/qrcode-ios.png" alt="" />
                </a>
              </div>
              <!-- 点我下载 -->
              <div class="qrcode-dw">
                <a
                  href="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282"
                  target="_blank"
                >
                  <img
                    v-show="isbuyIconEn"
                    src="../assets/index/dw_en.png"
                    alt="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282"
                  />
                  <img
                    v-show="isbuyIconZh"
                    src="../assets/index/dw_zh.png"
                    alt="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282"
                  />
                </a>
              </div>
              <div class="qrcode-version">
                <span>
                  <a
                    href="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282"
                    target="_blank"
                  >
                    <img
                      src="../assets/index/ma.png"
                      class="xiazaitu"
                      alt="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282"
                  /></a>
                </span>
                <span>
                  <a
                    href="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282"
                    target="_blank"
                    ><img
                      src="../assets/index/ma2.png"
                      class="xiazaitu"
                      alt="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282"
                  /></a>
                </span>
              </div>
            </div>
            <!-- apk -->
            <div class="qrcode-system" @click="goDown">
              <div class="qrcode-mobile">
                <a class="erwma"
                  ><img src="../assets/index/qrcode-akp.png" alt=""
                /></a>
              </div>
              <div class="qrcode-dw">
                <a>
                  <img
                    v-show="isbuyIconEn"
                    src="../assets/index/dw_en.png"
                    alt=""
                  />
                  <img
                    v-show="isbuyIconZh"
                    src="../assets/index/dw_zh.png"
                    alt=""
                  />
                </a>
              </div>
              <div class="qrcode-version">
                <span>
                  <a>
                    <img src="../assets/index/apk.png" class="xiazaitu" alt=""
                  /></a>
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Telegram  lia=-->
        <div id="fbBtn-wrap">
          <div class="fb-wrap">
            <!-- <div>Tiger777</div> -->
            <a href="https://t.me/+F8X9lq36hC81M2Jl" target="_blank">
              <img
                src="../assets/index/liaotian.png"
                style="width: 9.375rem; height: 3.125rem"
                alt=""
              />
            </a>
          </div>
          <div class="fb-wrap" style="margin-top: 0.5rem;">
            <!-- <div>Tiger777</div> -->
            <a
              href="https://www.facebook.com/profile.php?id=100095166211902"
              target="_blank"
            >
              <img
                src="../assets/index/facebook.png"
                style="width: 9.375rem; height: 3.125rem"
                alt=""
              />
            </a>
          </div>
        </div>
        <div class="zhan"></div>
      </div>
    </div>
    <Footer></Footer>
    <Login-pop ref="LoginPop"></Login-pop>
    <activity ref="isActivity"></activity>
    <router-view></router-view>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from "vuex";
import activity from "../components/activity.vue";
import "../assets/h5/h5dex.css";
export default {
  components: { activity },
  data() {
    return {
      lang: "4",
      isbuyIconEn: true,
      isbuyIconZh: false,
      active: 0,
      allList: [],
      newColor: ["new0", "new1", "new2", "new3"],
      carouselImg: [],
      newsList: [],
      isNoNews: false
    };
  },
  created() {
    this.showAll();
    this.changeIcon();
    this.getBannerList();
    this.getNewsList();
  },
  mounted() {
    this.$nextTick(() => {
      this.changeIcon();
    }),
      this.$store.commit("setActivity", 0);
  },
  beforeDestroy() {
    this.$store.commit("setActivity", 0);
  },
  computed: {
    //获取STORE里isApp
    ...mapState({
      isApp(state) {
        return state.isApp;
      },
      hasLogin(state) {
        return state.hasLogin;
      }
    })
  },
  methods: {
    getBannerList() {
      var _that = this;
      let obj = {
        lang: _that.lang
      };
      this.$FucPost(this.$store.state.ip + "/getBannerList", obj)
        .then(function(res) {
          // console.log(res);
          _that.carouselImg = res;
          // console.log('_that.carouselImg',_that.carouselImg)
        })
        .catch(err => {
          console.log(err);
        });
    },
    getNewsList() {
      var _that = this;
      let obj = {
        lang: _that.lang
      };
      //  服务端获取 活动系统
      this.$FucPost(this.$store.state.ip + "/getNewsList", obj)
        .then(function(res) {
          // console.log(res);
          _that.newsList = res;
          // console.log('_that.newsList',_that.newsList)
          _that.allList = _that.newsList[0].data;
          if (
            _that.allList == undefined ||
            _that.allList == "" ||
            _that.allList == null
          ) {
            _that.isNoNews = true;
          } else {
            _that.isNoNews = false;
          }
          // console.log("_that.allList", _that.allList);
        })
        .catch(err => {
          console.log(err);
        });
    },
    test() {},
    showAll() {
      var langNum = localStorage.getItem("lang");
      // console.log('langNum',langNum)
      if (langNum == "zh") {
        this.lang = 3;
      }
      if (langNum == "en") {
        this.lang = 4;
      }
      // console.log('this.lang',this.lang)
      // console.log('---123--',this.newsList);
    },
    changeNews(e, index) {
      // console.log("e", e);
      // console.log("index", index);
      this.allList = e.data;
      if (
        this.allList == undefined ||
        this.allList == "" ||
        this.allList == null
      ) {
        this.isNoNews = true;
      } else {
        this.isNoNews = false;
      }
      // console.log("e", this.allList);
      this.active = index;
    },
    changeIcon() {
      let lang = localStorage.getItem("lang");
      if (lang == "en") {
        this.isbuyIconEn = true;
        this.isbuyIconZh = false;
      }
      if (lang == "zh") {
        this.isbuyIconEn = false;
        this.isbuyIconZh = true;
      }
    },
    goWhere() {
      // console.log('1111',this.hasLogin)
      if (this.hasLogin == false) {
        this.$refs.LoginPop.showLogin();
      }
    },
    goNews(e) {
      // console.log(e)
      this.$router.push({
        name: "news",
        params: {
          details: e.content,
          content: e.title
        }
      });
    },
    goBannerNews(e) {
      // console.log(e)
      this.$router.push({
        name: "news",
        params: {
          details: e.jumpurl,
          content: e.title
        }
      });
    },
    goDown() {
      this.$router.push("/Down");
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  background: #ad0000 url("../assets/index/bg-pc-head.jpg") center top no-repeat;
  background-size: 100% auto;
}
.main_content {
  width: 75%;
  float: right;
}
.zanwie {
  height: 1.25rem;
}
.el-carousel {
  border: 0.0625rem solid rgb(209, 160, 38);
  background-color: rgb(209, 160, 38);
  padding: 0.125rem 0;
  border-bottom-left-radius: 0.625rem;
  border-bottom-right-radius: 0.625rem;
}
// .el-carousel__item {
//   // margin-top: 1.25rem;
// }
.el-carousel__item img {
  color: #475669;
  line-height: 22.5rem;
  width: 55.5rem;
  height: 21.875rem;
}
.dianji {
  width: 6.5rem;
  margin: 0.3125rem auto;
}
.news {
  width: 56.5rem;
  // height: 29.375rem;
  background-color: rgb(226, 196, 33);
  border-radius: 0.625rem;
  position: relative;
}
.new_title {
  height: 3rem;
  font-size: 2rem;
  line-height: 3rem;
  color: #351003;
}
.news_list {
  display: flex;
  flex-direction: row;
  width: 54.6875rem;
  border: 0.0625rem solid #e25b2a;
  border-radius: 0.3125rem;
  margin: 0 auto;
}
.news_list_title {
  width: 25%;
}
.new0 {
  padding: 0.625rem 0;
  font-size: 1.5625rem;
  color: aliceblue;
  background-image: linear-gradient(180deg, #ffb54b, #ea8c18 55%, #df7900);
}
// .newColorAA {
// }
.colorBlack {
  color: red;
}
.colorWhite {
  color: aliceblue;
}
.isapp_colorBlack {
  font-size: 1.2rem;
  font-weight: 700;
  color: red;
}
.isapp_colorWhite {
  font-size: 1.2rem;
  font-weight: 700;
  color: aliceblue;
}
.new1 {
  padding: 0.625rem 0;
  font-size: 1.5625rem;
  color: aliceblue;
  background-image: linear-gradient(180deg, #0dbb05, #0b9404 55%, #0a8804);
}
.new2 {
  padding: 0.625rem 0;
  font-size: 1.5625rem;
  color: aliceblue;
  background-image: linear-gradient(180deg, #0a78d6, #075da6 55%, #044a4e);
}
.new3 {
  padding: 0.625rem 0;
  font-size: 1.5625rem;
  color: aliceblue;
  background-image: linear-gradient(180deg, #5d1fbc, #4b0fa7 55%, #490ca5);
}
.isapp_itemSub {
  // position: absolute;
  display: flex;
  flex-direction: row;
  text-align: center;
  align-items: center;
  border-bottom: 0.0625rem solid rgb(202, 202, 202);
  border-left: 0.0625rem solid rgb(137, 137, 137);
  border-right: 0.0625rem solid rgb(137, 137, 137);
  width: 100%;
  margin: 0 auto;
  height: 3.125rem;
  line-height: 3.125rem;
  background: rgb(202, 202, 202);
}
.itemSub {
  // position: absolute;
  display: flex;
  flex-direction: row;
  text-align: center;
  border-bottom: 0.0625rem solid rgb(202, 202, 202);
  border-left: 0.0625rem solid rgb(137, 137, 137);
  border-right: 0.0625rem solid rgb(137, 137, 137);
  width: 100%;
  margin: 0 auto;
  height: 3.125rem;
  line-height: 3.125rem;
  background: rgb(202, 202, 202);
}
.itemSub first-child {
  // position: absolute;
  display: flex;
  flex-direction: row;
  text-align: center;
  border-bottom: 0.0625rem solid rgb(202, 202, 202);
  border-left: 0.0625rem solid rgb(137, 137, 137);
  border-right: 0.0625rem solid rgb(137, 137, 137);
  width: 53.6875rem;
  margin: 0 auto;
  height: 3.125rem;
  line-height: 3.125rem;
  background: rgb(122, 6, 6);
}
.itemSub_content:hover {
  text-decoration: underline;
  color: #0a78d6;
}
.itemSub_type {
  padding-left: 0.5rem;
  // background-color:rgb(7, 96, 172);
}
.itemSub_type_sub {
  background-color: rgb(7, 96, 172);
  height: 1.875rem;
  padding: 0 0.3125rem;
  line-height: 1.875rem;
  margin-top: 0.625rem;
  color: aliceblue;
  border-radius: 0.3125rem;
  // font-size: 1.25rem;
}
.itemSub_time {
  padding-left: 1.25rem;
  color: red;
  font-weight: 600;
  font-size: 1.25rem;
}
.itemSub_content {
  padding-left: 1.25rem;
  font-size: 1.25rem;
  color: black;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.more {
  width: 54.6875rem;
  margin: 0 auto;
  line-height: 2.5rem;
  bottom: 0;
  left: 45%;
  height: 2.5rem;
  border-top: none;
  border-left: 0.125rem solid rgba(0, 0, 0, 0.514);
  border-right: 0.125rem solid rgba(0, 0, 0, 0.514);
  border-bottom: 0.125rem solid rgba(0, 0, 0, 0.514);
  color: black;
  font-size: 1.5625rem;
}
.more_look {
  align-items: center;
  background-image: linear-gradient(0deg, #d8cc0f, #e6ac29);
  display: flex;
  justify-content: center;
  .more_look span {
    display: block;
  }
  .el-icon-caret-right {
    font-size: 1.875rem;
    // margin-top: 0.625rem;
  }
}
.zanwei_sub {
  width: 54.6875rem;
  height: 18.75rem;
  overflow-x: hidden;
  margin: 0 auto;
  background-color: #e2c421;
  padding-bottom: 0.625rem;
}
.isapp_carousel {
  width: 23.4375rem;
  height: 9.125rem;
}
// .carousel {
//   // width: 23.4375rem;
//   //   height: 12.5rem;
// }
.isapp_carousel_img {
  width: 100%;
}
/deep/ .el-carousel {
  z-index: 0;
}
.xia_left_center img {
  width: 5.9375rem;
  height: 1.9375rem;
}
.xia_left_btm img {
  width: 5.9375rem;
  height: 1.9375rem;
}
.xiazaitu {
  width: 5.9375rem;
  height: 1.9375rem;
}
.fb-wrap {
  font-weight: 600;
}
/deep/ .el-carousel__item img {
  color: #475669;
  line-height: 22.5rem;
  width: 100%;
  height: auto;
}
.noNews {
  width: 100%;
  height: 3.125rem;
  background: #cacaca;
  line-height: 3.125rem;
  font-size: 1.25rem;
  border: 0.0625rem solid #898989;
}
</style>
